import React, { useState } from 'react'
import { Box, Button, Checkbox, TextField } from '@mui/material'
import { ContentFilterType } from './types'
import { useToggleState } from 'shared/hooks'

export function ContentFilter({
  contentFilters,
  onFiltersChanged,
}: {
  contentFilters?: ContentFilterType
  onFiltersChanged(filters: ContentFilterType): void
}) {
  const [adding, setAdding] = useToggleState(false)

  const onAdd = (filter: ContentFilterType) => {
    onFiltersChanged({
      ...contentFilters,
      ...filter,
    })
    setAdding(false)
  }

  const allOrOption = (ALL_OR: boolean) => {
    onFiltersChanged({
      ...contentFilters,
      ALL_OR,
    } as ContentFilterType)
  }

  const onRemove = (toRemove: string) => {
    const { [toRemove]: _, ...rest } = contentFilters ?? {}
    onFiltersChanged(rest)
  }

  return (
    <Box>
      <Button onClick={() => setAdding()}>
        {adding ? 'Cancel' : 'Add Content Filter'}
      </Button>
      {adding && <ContentFilterAdd onAdd={onAdd} />}
      <ContentFilterDisplay
        filter={contentFilters}
        onRemove={onRemove}
        allOrToggle={allOrOption}
      />
    </Box>
  )
}

function ContentFilterDisplay({
  filter,
  onRemove,
  allOrToggle,
}: {
  filter?: ContentFilterType
  onRemove(content: string): void
  allOrToggle(o: boolean): void
}) {
  const { ALL_OR = false, ...rest } = filter ?? {}
  const filters = Object.entries(rest)
  if (!filters.length) return null
  return (
    <Box padding="10px" borderRadius="5px" border={'1px solid'}>
      <Box>Content Filters:</Box>
      {filters.length > 1 && (
        <Box>
          All Or?{' '}
          <Checkbox checked={ALL_OR} onClick={() => allOrToggle(!ALL_OR)} />
        </Box>
      )}
      <Box
        padding="10px"
        borderRadius="5px"
        style={{ backgroundColor: 'lightgoldenrodyellow' }}
      >
        {filters.map(([content, filter]) => {
          const { filterType, caseInsensitive } = filter
          const caseVal = `(Case ${caseInsensitive ? 'Ins' : 'S'}ensitive)`
          return (
            <Box key={content}>
              {`${filterType}: ${content} ${caseVal}`}
              <Button onClick={() => onRemove(content)}>X</Button>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

function ContentFilterAdd({ onAdd }: { onAdd(f: ContentFilterType): void }) {
  const [including, setIncluding] = useState(true)
  const [content, setContent] = useState('')
  const [caseInsensitive, setCaseInsensitive] = useState(false)
  const doAdd = () => {
    onAdd({
      [content]: {
        filterType: including ? 'including' : 'excluding',
        caseInsensitive,
      },
    })
    setIncluding(true)
    setContent('')
  }
  return (
    <Box>
      <TextField
        value={content}
        label="Filter Content"
        onChange={({ target: { value } }) => setContent(value)}
      />
      Including:{' '}
      <Checkbox
        onChange={() => setIncluding((prev) => !prev)}
        checked={including}
      />
      Case Sensitive:{' '}
      <Checkbox
        onChange={() => setCaseInsensitive((prev) => !prev)}
        checked={!caseInsensitive}
      />
      <Button onClick={doAdd}>Add</Button>
    </Box>
  )
}
